import { LearnerPositionDto } from '../dtos/learner-position.dto';
import { LearnerPosition } from '../models/learner-position';

/**
 * Map learner position from dto.
 * @param {LearnerPositionDto} dto Dto.
 * @returns {LearnerPosition}
 */
function fromDto(dto) {
  return {
    id: dto.id,
    name: dto.name,
    language: dto.language,
  };
}

export const learnerPositionMapper = {
  fromDto,
};
